import { styled } from 'parkdepot-shared/theme'

export const Container = styled<'div', { $mobile?: boolean; $mobileNoImage?: boolean }>(
    'div',
    ({ $theme, $mobile = false, $mobileNoImage = false }) => ({
        ...($mobile || $mobileNoImage
            ? {
                  width: '20%',
                  marginBottom: '1.8rem'
              }
            : {
                  width: '20%'
              }),
        ...($mobileNoImage && {
            position: 'absolute',
            left: '1.2rem',
            display: 'flex',
            gap: '8px',
            verticalAlign: 'center',
            top: '0',
            alignItems: 'center',
            color: $theme.colors.primary,
            cursor: 'pointer',
            marginBottom: 0
        })
    })
)

export const Back = styled('button', ({ $theme }) => ({
    // Reset button styles
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',

    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    color: $theme.colors.primary,
    cursor: 'pointer',

    // keep focus-visible for keyboard nav
    outline: 'none',
    ':focus-visible': {
        outline: `2px solid ${$theme.colors.accent}`,
        outlineOffset: '2px'
    }
}))
